import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function MartialArtsNearMeScheduleLocation() {
  return <section className="py-24 bg-off-white" data-id="element-2488">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2489">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-2490">
          <div data-id="element-2491">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2492">Class Times</h2>
            <ScheduleTable data-id="element-2493" />
          </div>
          <div data-id="element-2494">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2495">
              Taekwondo Classes in Farmington Hills, MI
            </h2>
            <LocationBlock data-id="element-2496" />
          </div>
        </div>
      </div>
    </section>;
}